import { render, staticRenderFns } from "./r-back-button.vue?vue&type=template&id=3c1a680e&scoped=true"
var script = {}
import style0 from "./r-back-button.vue?vue&type=style&index=0&id=3c1a680e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1a680e",
  null
  
)

export default component.exports